import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from '../interfaces/reducer';

const initialState: IState = {
  dataDemo: [],
  dataStores: null,
  storeListParams : {
    page: 1,
    size: 10,
  },
  screenListInStore: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getDemoData.success, (state, { payload }) => {
        state.dataDemo = payload;
      })
      .addCase(actions.getListStores.success, (state, { payload }) => {
        state.dataStores = payload;
      })
      .addCase(actions.setListStoresParams, (state, { payload }) => {
        state.storeListParams = payload;
      })
      .addCase(actions.getListScreensInStore.success, (state, { payload }) => {
        state.screenListInStore = payload;
      });
  },
});

/** TODO:
 * please replace store => your feature name
 * ex:
 *      my feature is booking 
 *  name sagas like
 *      storeServiceReducer => bookingServiceReducers
 * 
 * // TODO:
 * Move to rootReducer (src/store/root/reducers.ts) and import your feature reducer
 */
export const storeUIActions = Slice.actions;
const storeServiceReducer = Slice.reducer;
export default storeServiceReducer;
